var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.1 181.094C440 220.294 433.7 262.494 382.7 282.594C331.6 262.494 325.4 220.294 325.3 181.094H440.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.6 197.694C436.8 232.594 427.2 265.094 382.6 282.694C338.2 265.094 328.1 231.494 325.7 197.794",
    fill: "#29DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.8 214.094C434.6 238.394 421.1 267.594 382.7 282.694C344.3 267.594 332.2 240.194 327.6 214.294",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.2 230.294C428.5 247.994 414.9 269.694 382.9 283.094C350.9 270.494 337.7 249.294 331.5 230.094",
    fill: "#29DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 246.894C420.2 258.194 409 272.294 382.7 282.794C355.2 271.294 345.3 257.494 338.7 246.694",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.4 265.094C404.3 272.294 400.4 276.294 382.8 282.994C362.7 275.094 360.2 271.394 353.6 265.494",
    fill: "#29DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3 231.594C383.1 231.394 355.4 267.294 355.4 267.294C353.6 265.994 345.4 257.794 342.1 252.294L383.4 202.194L423.6 251.894C419.7 258.394 412.2 265.494 410.4 266.894L383.3 231.594ZM382.6 85.2941L356.1 130.294H409.1L382.6 85.2941Z",
    fill: "#5CC85C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.999 227.816C310.603 201.163 306.559 178.614 297.966 177.452C289.373 176.29 279.486 196.955 275.882 223.609C272.279 250.263 276.323 272.812 284.916 273.974C293.508 275.135 303.395 254.47 306.999 227.816Z",
    fill: "#F7A226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.8 167.349C312.21 161.354 311.173 155.291 307.484 153.808C303.794 152.324 298.85 155.982 296.439 161.978C294.029 167.973 295.066 174.036 298.756 175.519C302.445 177.002 307.39 173.344 309.8 167.349Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.966 272.163C295.871 265.932 295.142 260.669 293.339 260.407C291.535 260.145 289.339 264.984 288.435 271.214C287.53 277.445 288.259 282.708 290.062 282.97C291.866 283.232 294.061 278.394 294.966 272.163Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.198 280.388C302.018 280.29 303.23 275.293 302.905 269.227C302.58 263.16 300.841 258.321 299.021 258.419C297.201 258.516 295.989 263.513 296.314 269.58C296.639 275.647 298.378 280.486 300.198 280.388Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.542 213.851C321.649 213.021 321.107 206.641 318.332 199.602C315.556 192.563 311.599 187.53 309.492 188.361C307.386 189.191 307.928 195.571 310.703 202.61C313.478 209.649 317.436 214.682 319.542 213.851Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.013 181.911C326.052 179.136 331.085 175.178 330.254 173.071C329.424 170.965 323.044 171.507 316.005 174.282C308.966 177.058 303.934 181.015 304.764 183.122C305.595 185.228 311.974 184.686 319.013 181.911Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.133 274.179C488.725 273.017 492.77 250.468 489.166 223.814C485.562 197.161 475.675 176.495 467.082 177.657C458.49 178.819 454.445 201.368 458.049 228.022C461.653 254.675 471.54 275.341 480.133 274.179Z",
    fill: "#F7A226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.381 175.769C470.07 174.285 471.107 168.223 468.697 162.227C466.287 156.232 461.342 152.574 457.653 154.057C453.963 155.541 452.926 161.603 455.336 167.599C457.747 173.594 462.692 177.252 466.381 175.769Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.037 283.157C476.841 282.895 477.569 277.631 476.663 271.401C475.758 265.17 473.561 260.332 471.758 260.594C469.954 260.856 469.226 266.12 470.132 272.35C471.037 278.581 473.234 283.419 475.037 283.157Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.776 269.752C469.101 263.686 467.89 258.688 466.07 258.591C464.25 258.493 462.511 263.332 462.185 269.399C461.86 275.466 463.072 280.463 464.892 280.56C466.712 280.658 468.451 275.819 468.776 269.752Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.34 202.683C457.115 195.644 457.657 189.265 455.551 188.434C453.444 187.604 449.487 192.636 446.712 199.675C443.936 206.714 443.394 213.094 445.501 213.924C447.607 214.755 451.565 209.722 454.34 202.683Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.365 183.278C461.196 181.172 456.163 177.214 449.124 174.439C442.085 171.664 435.705 171.122 434.875 173.228C434.044 175.335 439.077 179.292 446.116 182.068C453.155 184.843 459.534 185.385 460.365 183.278Z",
    fill: "#DDC7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3 130.294L356.1 154.994L373.9 181.094H396L400.7 155.694L395.3 130.294H373.3Z",
    fill: "#B0C6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -0.00585938V117.394H209.9L256 148.094V170.694H233.4L160 121.794V170.694H96V121.794L22.6 170.694H0V148.094L46.1 117.394H0V53.3941H46.1L0 22.6941V-0.00585938H22.6L96 48.8941V-0.00585938H160V48.8941L233.4 -0.00585938H256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 -0.00585938H112V69.3941H0V101.394H112V170.694H144V101.394H256V69.3941H144V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 22.6942V53.3942H209.9L256 22.6942Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.694V159.694L62.5 117.394H85.1L7.3 170.694H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 0.0941162L85.1 53.2941H62.5L0 11.0941V0.0941162H7.3ZM256 0.0941162V11.0941L193.5 53.3941H170.9L248.7 0.0941162H256ZM248.7 170.694L170.9 117.394H193.5L256 159.694V170.694H248.7Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/AC.6562728a3ae5e0f162aadb816ba83043.svg";
export { ForwardRef as ReactComponent };